export function extractForumPostId(forumPostIdsCombo: string): string {
  const ids = forumPostIdsCombo.split('~');
  // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return ids[ids.length - 1];
}
